import { Modal, Tabs } from 'antd';
import React, { useState, useRef } from 'react';
import moment from 'moment';

import { LocalPersistence } from '../../../../../factories';
import { delPolicyTax, putPolicyTax } from '../../../../../services/policy';
import TaxEdit from './TaxesEdit';
import TaxDetails from './TaxDetails';
import ActionButtonsBar from '../../../../ui/ActionButtonsBar';
const dateFormat = 'MM/DD/YYYY';
const { TabPane } = Tabs;

const GPDetails = (props: any) => {
  const [rowEditData, setRowEditData] = useState(props.cancellationDetails);
  const [eidtFlag, setEditFlag] = useState(false);
  const [disabledStatus, setDisabledStatus] = useState(true);
  const toggleToEditMode = () => {
    props.isEditable();
    setEditFlag(true);
  };
  const detailEditRef = useRef<any>();
  const addSave = () => {
    detailEditRef.current.detailsForm
      .validateFields()
      .then(async (detailsValue: any) => {
        const editObj: any = {};
        editObj.name = detailsValue.name || '';
        editObj.startdate =
          (detailsValue.rating &&
            detailsValue.rating[0] &&
            moment(detailsValue.rating[0]).format(dateFormat)) ||
          '';
        editObj.enddate =
          (detailsValue.rating &&
            detailsValue.rating[1] &&
            moment(detailsValue.rating[1]).format(dateFormat)) ||
          '';
        editObj.taxtype = detailsValue.taxtype || '';
        editObj.type = detailsValue.type || '';
        editObj.chargetype = detailsValue.chargetype || '';
        editObj.chargeamount = detailsValue.chargeamount || '';
        if (editObj.chargetype === 'Amount') {
          editObj.currency = detailsValue.currency || '';
        }
        editObj.chargefrequency = detailsValue.chargefrequency || '';
        editObj.chargeunit = detailsValue.chargeunit || '';
        editObj.sequence = detailsValue.sequence || '';
        editObj.description = detailsValue.description || '';

        const get_session = new LocalPersistence('session');
        const session: any = await get_session.getSessionPersistence();
        const paramsDetails = {
          supplier: session.supplier,
          propertyId: session.propertyId,
          property: {
            policies: {
              taxpolicy: [
                {
                  taxid: props.cancellationDetails.taxid,
                  taxlangid: props.cancellationDetails.taxlangid,
                  ...editObj,
                },
              ],
            },
          },
        };
        putPolicyTax(paramsDetails).then((res) => {
          props.cancelEditable();
          setRowEditData(editObj);
          setEditFlag(false);
        });
      });
  };
  const ModalHead = () => {
    return (
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          height: '50px',
          lineHeight: '50px',
          textIndent: '10px',
          borderBottom: '1px solid #ccc',
          color: '#fff',
          background: '#06789D',
          fontSize: 18,
          width: '100%',
        }}
      >
        Confirm
      </div>
    );
  };
  const DeleteClick = async () => {
    const get_session = new LocalPersistence('session');
    const session: any = await get_session.getSessionPersistence();
    const params = {
      supplier: session.supplier,
      propertyId: session.propertyId,
      property: {
        policies: {
          taxpolicy: [
            {
              taxid: props.cancellationDetails.taxid,
              taxlangid: props.cancellationDetails.taxlangid,
            },
          ],
        },
      },
    };
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content: `Are you sure you want to delete ${rowEditData.name} ?`,
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk: async () => {
        const res = await delPolicyTax(params);
        if (res.result.success) {
          props.cancelEditable();
          await props.getPoliciesData('Taxes');
        }
      },
      onCancel() {},
    });
  };

  const validateFieldsError = (isDisabled?: boolean) => {
    if (isDisabled) {
      setDisabledStatus(isDisabled);
      return;
    }
    detailEditRef.current.detailsForm
      .validateFields()
      .then(() => {
        setDisabledStatus(false);
      })
      .catch(() => {
        const errTotalNum = detailEditRef?.current?.detailsForm
          ?.getFieldsError()
          ?.filter(({ errors }: { errors: any }) => errors.length).length;

        if (errTotalNum === 0) {
          setDisabledStatus(false);
        } else {
          setDisabledStatus(true);
        }
      });
  };
  return (
    <>
      <Tabs defaultActiveKey={props.activeTabKey}>
        <TabPane
          tab="Detail"
          key="Detail"
          forceRender={true}
        >
          {!eidtFlag ? (
            <TaxDetails
              cancellationDetails={rowEditData}
              toggleToEditMode={toggleToEditMode}
              setActiveTabKey={props.setActiveTabKey}
            />
          ) : (
            <TaxEdit
              validateFieldsError={validateFieldsError}
              cancellationDetails={rowEditData}
              ref={detailEditRef}
            />
          )}
        </TabPane>
      </Tabs>
      <ActionButtonsBar
        onDelete={DeleteClick}
        onCancel={() => {
          props.cancelEditable();
          setEditFlag(false);
        }}
        onSave={addSave}
        disabledSave={disabledStatus}
        show={eidtFlag}
      />
    </>
  );
};
export default GPDetails;
